"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.validate = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var utils = _interopRequireWildcard(require("@tencent/imutils"));

require("./index.scss");

// input 通用控件
const validateMap = {
  phoneNumber: [{
    reg: /^1\d{10}$/,
    tips: '手机格式错误'
  }],
  smsCode: [{
    reg: /^\d{6}$/,
    tips: '验证码错误'
  }]
};
const loginTypeErrorMap = {
  phoneNumber: {
    phoneNumberEmpty: '请输入手机号'
  },
  smsCode: {
    CodeError: '验证码错误'
  }
};

const validate = (value, validateType) => {
  const validateRules = validateMap[validateType] || [];
  let rtnTips;
  const rtnValid = validateRules.every(rule => {
    const reg = rule.reg,
          tips = rule.tips;

    if (value && !reg.test(value)) {
      rtnTips = tips;
      return false;
    }

    return true;
  });
  return {
    valid: rtnValid,
    tips: rtnTips
  };
};

exports.validate = validate;

class InputComponent extends _react.default.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onFocus", () => {
      var _this$props;

      if (this.inputWrap) {
        this.setState({
          inputFocus: true
        });
        this.inputWrap.classList.add('active');
      }

      utils.tdwReport.report({
        event: 'click',
        module: `${this === null || this === void 0 ? void 0 : (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.name}_input_click`
      });
    });
    (0, _defineProperty2.default)(this, "onInput", e => {
      const originValue = e.currentTarget.value;
      const _this$props2 = this.props,
            onInput = _this$props2.onInput,
            _this$props2$setLogin = _this$props2.setLoginTypeError,
            setLoginTypeError = _this$props2$setLogin === void 0 ? () => {} : _this$props2$setLogin;
      const value = this.filterValue(originValue);
      setLoginTypeError('');
      onInput(value, this.validate(value));
      this.setState({
        value,
        originValue
      });
    });
    (0, _defineProperty2.default)(this, "onBlur", () => {
      const input = this.input;
      const _this$props3 = this.props,
            isError = _this$props3.isError,
            tips = _this$props3.tips,
            defaultTips = _this$props3.defaultTips;

      if (input) {
        const value = input.value;

        const _this$validate = this.validate(value),
              valid = _this$validate.valid,
              errorTips = _this$validate.tips;

        this.inputWrap.classList.remove('active');

        if (!value) {
          this.showTips(false, defaultTips);
        } else {
          this.showTips(isError || !valid, errorTips || tips);
        } //  手机号


        if (value && value.length === 11) {
          input.blur();
        } // 错误提示文案优先级: 组件自带格式检验 -> 组件外传入的 tips


        this.setState({
          inputFocus: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "onClickInputWrap", () => {
      const name = this.props.name;

      if (name === 'phone') {
        // ???
        utils.tdwReport.report({
          event: 'click',
          // 事件名
          module: 'phone_input'
        });
      }

      this.input.focus();
    });
    (0, _defineProperty2.default)(this, "cancelValue", () => {
      const _this$props4 = this.props,
            onInput = _this$props4.onInput,
            defaultTips = _this$props4.defaultTips;
      this.input.value = '';
      onInput('', this.validate(''));
      this.input.focus();
      this.showTips(false, defaultTips);
      this.setState({
        value: ''
      });
    });
    (0, _defineProperty2.default)(this, "togglePwdVisible", () => {
      const isPwdVisible = this.state.isPwdVisible;
      this.setState({
        isPwdVisible: !isPwdVisible
      });
    });
    (0, _defineProperty2.default)(this, "inputRef", node => {
      this.input = node;
    });
    (0, _defineProperty2.default)(this, "inputWrapRef", node => {
      this.inputWrap = node;
    });
    (0, _defineProperty2.default)(this, "renderInput", () => {
      const _this$state = this.state,
            isPwdVisible = _this$state.isPwdVisible,
            value = _this$state.value,
            originValue = _this$state.originValue;
      let _this$props5 = this.props,
          _this$props5$type = _this$props5.type,
          type = _this$props5$type === void 0 ? 'text' : _this$props5$type,
          _this$props5$name = _this$props5.name,
          name = _this$props5$name === void 0 ? '' : _this$props5$name,
          maxLength = _this$props5.maxLength,
          autofocus = _this$props5.autofocus;

      if (type === 'password') {
        type = isPwdVisible ? 'text' : 'password';
      }

      return /*#__PURE__*/_react.default.createElement("input", {
        type: type,
        value: value,
        defaultValue: originValue,
        name: name,
        className: "form-login-ipt",
        ref: this.inputRef,
        onClick: this.onClick,
        onFocus: this.onFocus,
        onInput: this.onInput,
        onChange: this.onInput,
        maxLength: maxLength // autoComplete="new-password"
        ,
        autoComplete: "off" // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autofocus
      });
    });
    (0, _defineProperty2.default)(this, "renderPlaceholder", () => {
      const _this$state2 = this.state,
            inputFocus = _this$state2.inputFocus,
            value = _this$state2.value;
      const _this$props$placehold = this.props.placeholder,
            placeholder = _this$props$placehold === void 0 ? '' : _this$props$placehold; // 没有焦点并且没有值 显示 placeholder

      if (!inputFocus && !value) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "placeholder",
          onClick: this.onFocus
        }, placeholder);
      }
    });
    (0, _defineProperty2.default)(this, "renderTips", () => {
      const _this$props6 = this.props,
            loginTypeError = _this$props6.loginTypeError,
            validateType = _this$props6.validateType,
            setErrorTips = _this$props6.setErrorTips,
            type = _this$props6.type;
      let tips = this.state.tips;

      if (loginTypeError) {
        tips = loginTypeErrorMap[validateType][loginTypeError];
      }

      setErrorTips(tips, type);
      console.log(' 展示 错误信息 ', tips, type);
    });
    const _this$props7 = this.props,
          _value = _this$props7.value,
          _defaultTips = _this$props7.defaultTips,
          _isPwdVisible = _this$props7.isPwdVisible;
    this.state = {
      value: _value,
      tips: _defaultTips,
      isPwdVisible: _isPwdVisible
    };
  }

  componentDidMount() {
    document.addEventListener('click', e => {
      const target = e.target;

      if (target !== this.input && !['svg', 'path'].includes(target.tagName) && !utils.closest(target, '.js-ignore-blur')) {
        this.onBlur();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.checkShowTips(nextProps);
  }

  filterValue(val) {
    const validateType = this.props.validateType;

    if (validateType === 'phoneNumber' || validateType === 'smsCode') {
      // 过滤非数字类型
      return val.replace(/[^\d]/g, '');
    }

    return val;
  } // 外部更新提示


  checkShowTips(nextProps) {
    const _this$props8 = this.props,
          isError = _this$props8.isError,
          tips = _this$props8.tips;
    const nextIsError = nextProps.isError,
          nextTips = nextProps.tips;

    if (isError !== nextIsError || tips !== nextTips) {
      this.showTips(nextIsError, nextTips);
    }
  }

  showTips(isError = true, errorTips = '') {
    const classList = this.inputWrap.classList;

    if (isError) {
      classList.add('error');
    } else {
      classList.remove('error');
    }

    this.setState({
      // isError,
      tips: errorTips
    });
  } // 校验值是否合法


  validate(value) {
    const validateType = this.props.validateType;
    return validate(value, validateType);
  } // 清除文本框的内容


  render() {
    const _this$props9 = this.props,
          className = _this$props9.className,
          children = _this$props9.children;
    const cls = (0, _classnames.default)('ipt-wrap', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cls,
      ref: this.inputWrapRef,
      onClick: this.onClickInputWrap
    }, this.renderInput(), this.renderPlaceholder(), this.renderTips(), /*#__PURE__*/_react.default.createElement("div", {
      className: "helper-wrap"
    }, children));
  }

}

(0, _defineProperty2.default)(InputComponent, "defaultProps", {
  type: '',
  className: '',
  placeholder: '',
  onInput: () => {},
  setErrorTips: () => {},
  isPwdVisible: false,
  tips: '',
  defaultTips: '',
  isError: false
});
var _default = InputComponent;
exports.default = _default;